const commentsData = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20avatar%20with%20warm%20red%20gradient%20circle%20on%20light%20background%2C%20modern%20flat%20design%2C%20simple%20geometric%20style%2C%20no%20text&width=80&height=80&seq=avatar-01&orientation=squarish',
    name: '吃瓜不嫌事大',
    time: '2 小时前',
    content: '这个瓜我吃了三天了，越挖越深，感觉后面还有更大的料在等着爆。娱乐圈真的是每天都在上演现实版宫斗剧啊！',
    likes: '1.2k',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20avatar%20with%20amber%20orange%20circle%20on%20clean%20background%2C%20flat%20modern%20design%2C%20simple%20geometric%2C%20no%20text&width=80&height=80&seq=avatar-02&orientation=squarish',
    name: '理性吃瓜人',
    time: '3 小时前',
    content: '建议大家都先别急着站队，现在网上传的信息真真假假，等当事人或者官方出来说话再判断。理性吃瓜，不传谣不信谣。',
    likes: '856',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20avatar%20with%20coral%20pink%20rounded%20square%20on%20neutral%20background%2C%20clean%20flat%20design%2C%20no%20text&width=80&height=80&seq=avatar-03&orientation=squarish',
    name: '深夜瓜田守望者',
    time: '5 小时前',
    content: '我就想知道那个聊天记录到底是真的假的？如果是真的那也太精彩了吧！好久没见过这么刺激的互撕了。',
    likes: '2.3k',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20avatar%20with%20warm%20golden%20triangle%20on%20light%20background%2C%20modern%20geometric%20design%2C%20no%20text&width=80&height=80&seq=avatar-04&orientation=squarish',
    name: '八卦协会会长',
    time: '7 小时前',
    content: '作为资深吃瓜群众，我可以负责任地说：今年的瓜比去年精彩多了！从年初到现在基本上每个月都有大事件，太幸福了。',
    likes: '5.6k',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20avatar%20with%20deep%20red%20hexagon%20on%20clean%20background%2C%20modern%20geometric%20style%2C%20flat%20design%2C%20no%20text&width=80&height=80&seq=avatar-05&orientation=squarish',
    name: '瓜田里的猹',
    time: '9 小时前',
    content: '黑料大赛整理的时间线太清晰了，我终于把这个复杂的瓜理清楚了。收藏了，等后续更新！小编加油继续扒。',
    likes: '3.1k',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">瓜友热评</h2>
          <p className="mt-2 text-sm text-foreground-600">来自吃瓜群众的真实声音，看看大家都在聊什么</p>
        </div>

        <div className="flex flex-col gap-4">
          {commentsData.map((item, i) => (
            <div key={i} className="bg-background-50 rounded-2xl border border-background-200/70 p-5 hover:border-accent-200/50 transition-colors duration-200">
              <div className="flex items-start gap-4">
                <img
                  src={item.avatar}
                  alt={item.name}
                  className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{item.name}</span>
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{item.time}</span>
                  </div>
                  <p className="mt-2 text-sm text-foreground-700 leading-relaxed">{item.content}</p>
                  <div className="mt-3 flex items-center gap-4">
                    <button className="flex items-center gap-1 text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                      <i className="ri-thumb-up-line"></i> {item.likes}
                    </button>
                    <button className="flex items-center gap-1 text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                      <i className="ri-chat-1-line"></i> 回复
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}